export const MACHINE_ELECTRIC_POWER_UNIT = 'Watts';
export const MACHINE_INTENSITY_UNIT = 'Ampères';
export const MACHINE_INTENSITY_LABEL = 'Intensité électrique';

const hasNumericValue = (value) => value !== null && value !== undefined && value !== '';

export const formatMachineElectricPower = (value) => (
  hasNumericValue(value) ? `${value} ${MACHINE_ELECTRIC_POWER_UNIT}` : null
);

export const formatMachineIntensity = (value) => (
  hasNumericValue(value) ? `${value} ${MACHINE_INTENSITY_UNIT}` : null
);
